import { MaskedLines, Reveal, Overline } from "./shared";

const CAPABILITIES = [
    "Precision motion control", "Custom mechanical systems", "Servo & stepper technology",
    "Intelligent lighting", "Sensors", "Gesture interaction",
    "Programmable movement", "Real-time control", "Custom electronics", "Bespoke software",
];

const PILLARS = ["DESIGN", "ENGINEERING", "MOTION", "LIGHT", "INTERACTION"];

export const Technology = () => (
    <section data-testid="technology-section" className="relative border-t border-white/5 py-32 md:py-48">
        <div className="mx-auto max-w-[1600px] px-6 md:px-12">
            <Overline>The Technology Behind the Magic</Overline>
            <h2 className="mt-10 max-w-5xl font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight sm:text-5xl lg:text-7xl">
                <MaskedLines lines={["Behind the beauty", "is engineering."]} />
            </h2>
            <Reveal className="mt-10 max-w-xl">
                <p className="text-lg font-light leading-relaxed text-white/60 md:text-xl">
                    Invisible technology. Visible magic. You will never see a cable, hear a motor or notice a sensor — only the moment it creates.
                </p>
            </Reveal>
            <div className="mt-20 grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-5">
                {CAPABILITIES.map((c, i) => (
                    <Reveal key={c} delay={(i % 5) * 0.06} className="group bg-[#0A0A0C] p-8">
                        <span className="font-mono-tech text-[10px] tracking-[0.3em] text-white/25">{String(i + 1).padStart(2, "0")}</span>
                        <p className="mt-8 text-sm font-light tracking-wide text-white/70 transition-colors duration-500 group-hover:text-white">{c}</p>
                    </Reveal>
                ))}
            </div>
            <Reveal className="mt-20">
                <div className="flex flex-wrap items-center gap-x-6 gap-y-3">
                    {PILLARS.map((p, i) => (
                        <span key={p} className="flex items-center gap-6">
                            <span className="font-display text-xl font-bold uppercase tracking-[0.15em] text-white/85 md:text-2xl">{p}</span>
                            {i < PILLARS.length - 1 && <span className="font-mono-tech text-white/25">+</span>}
                        </span>
                    ))}
                </div>
            </Reveal>
        </div>
    </section>
);
